import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";

import {
  MACHINE_ICON_OPTIONS,
  loadSelectedMachineIcons,
  saveSelectedMachineIcons,
} from "./iconCatalog";

import "./IconGallery.css";

function traccarIcon(name) {
  try {
    return require(`../../assets/traccar/online/${name}.svg`);
  } catch (error) {
    return "";
  }
}

function platformIcon(name) {
  try {
    return require(`../../assets/platform/online/${name}.svg`);
  } catch (error) {
    return "";
  }
}

function IconGallery({ t }) {
  const { farm_id } = useParams();
  const [selected, setSelected] = useState(() => loadSelectedMachineIcons());

  useEffect(() => {
    document.title = "Agriconnected - Galeria de ícones";
  }, []);

  const toggle = (id) => {
    setSelected((current) => {
      const next = current.includes(id)
        ? current.filter((item) => item !== id)
        : current.concat(id);
      saveSelectedMachineIcons(next);
      return next;
    });
  };

  return (
    <div className="icon-gallery">
      <div className="x_title">
        <h2>{t("Galeria de ícones")}</h2>
        <div className="clearfix" />
      </div>
      <p className="icon-gallery__lead">
        {t(
          "Marque os ícones de máquina que o gestor poderá escolher no cadastro. O operador da telemetria é fixo e não entra nessa lista."
        )}
      </p>
      <p>
        <Link to={`/${farm_id}/`}>{t("Voltar ao painel")}</Link>
      </p>

      <div className="icon-gallery__locked">
        <div className="icon-gallery__map is-person">
          <img src={platformIcon("pedestrian")} alt={t("Operador")} />
        </div>
        <div>
          <div className="icon-gallery__name">{t("Operador")}</div>
          <div className="icon-gallery__note">
            {t("Operador para telemetria — sempre ao lado ou embaixo da máquina. Sem escolha.")}
          </div>
        </div>
      </div>

      <p className="icon-gallery__count">
        {t("Selecionados")}: {selected.length}
        {selected.length ? ` — ${selected.join(", ")}` : ""}
      </p>

      <h3>{t("Ícones de máquina — clique para marcar")}</h3>
      <div className="icon-gallery__row">
        {MACHINE_ICON_OPTIONS.map(([id, label]) => {
          const on = selected.includes(id);
          return (
            <button
              key={id}
              type="button"
              className={`icon-gallery__card${on ? " is-on" : ""}`}
              onClick={() => toggle(id)}
            >
              <div className="icon-gallery__map">
                <img src={traccarIcon(id)} alt={label} />
              </div>
              <div className="icon-gallery__name">{t(label)}</div>
              <div className="icon-gallery__note">{id}</div>
              <div className="icon-gallery__mark">{on ? t("Marcado") : t("Clique para marcar")}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default withTranslation()(IconGallery);
